module.exports = __webpack_public_path__ + "img/4.9569a3ee.png";